//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../Motion/Motion.EntityPropTableBuilder.js";
let d=[[],[],[]];
SPLM.Motion.GearBuilder = class extends SPLM.Motion.EntityPropTableBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.GearBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.GearBuilder.GeometryType = Object.freeze({
    "Internal" : "Internal", "External" : "External"});

SPLM.Motion.GearBuilder.HelixHand = Object.freeze({
    "Left" : "Left", "Right" : "Right"});

SPLM.Motion.GearBuilder.FlanksDependency = Object.freeze({
    "None" : "None", "Radial" : "Radial", "Axial" : "Axial", "Both" : "Both"});

SPLM.Motion.GearBuilder.MicroGeometryType = Object.freeze({
    "Default" : "Default", "Custom" : "Custom"});

export default SPLM;